export default {
  props: ["open"],
  methods: {
    closePopup() {
      this.$emit("update:open", false);
    },
  }
}
